import type {ButtonFormSchema, OptionalButtonFormSchema, UnsetBtnType} from './schema'
import type {BlockButtonInput, ButtonInterfaceFragment, DownloadButtonInput, NestedContentButtonInput} from '@sdox/api'

export const buttonFormToInput = (
  button: ButtonFormSchema | OptionalButtonFormSchema | UnsetBtnType | undefined,
): BlockButtonInput | null | undefined => {
  // let the button value as is
  if (button === undefined) return undefined

  // remove the button
  if (button.btnType === 'unset') return null
  // all other...
  if (button.btnType === 'btnNestedContent') {
    const btnNestedContent: NestedContentButtonInput = {
      ...button.btnNestedContent,
      identifier: button.btnNestedContent.identifier || undefined,
    }
    return {btnNestedContent}
  }
  if (button.btnType === 'btnDownload') {
    const btnDownload: DownloadButtonInput = {
      label: button.btnDownload.label,
      size: button.btnDownload.size,
      variant: button.btnDownload.variant,
      leadingIcon: button.btnDownload.leadingIcon,
      trailingIcon: button.btnDownload.trailingIcon,
      disclaimer: button.btnDownload.disclaimer,
      fileName: button.btnDownload.fileName,
      fileHash: button.btnDownload.media.fileHash,
    }
    return {btnDownload}
  }
  if (button.btnType === 'btnCopy') {
    return {
      btnCopy: button.btnCopy,
    }
  }
  if (button.btnType === 'btnDoc') {
    return {
      btnDoc: button.btnDoc,
    }
  }
  if (button.btnType === 'btnHref') {
    return {
      btnHref: button.btnHref,
    }
  }
  // Check that all cases of __typename have been handled
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const exhaustiveCheck: never = button
  return undefined
}

export const buttonFragmentToForm = (
  button: ButtonInterfaceFragment | null | undefined,
): ButtonFormSchema | OptionalButtonFormSchema | undefined => {
  // remove the button
  if (button === null) return {btnType: 'unset'}
  // let the button value as is
  if (button === undefined) return undefined

  if (button.__typename === 'ContactFormTriggerButtonType') {
    // TODO this should not be possible in editor, this is only valid if it comes from the server
    // let the button value as is
    return undefined
  }
  if (button.__typename === 'CopyButtonType') {
    const {__typename, ...btnCopy} = button
    return {
      btnType: 'btnCopy',
      btnCopy,
    }
  }
  if (button.__typename === 'HrefButtonType') {
    const {__typename, href, ...defaults} = button
    return {
      btnType: 'btnHref',
      btnHref: {
        ...defaults,
        url: href,
      },
    }
  }
  if (button.__typename === 'DocButtonType') {
    const {__typename, docIdentifier, document, ...defaults} = button
    let name = ''
    if (document.__typename === 'DocumentType') {
      name = document.displayName
    } else if (document.__typename === 'MobRecordType') {
      name = document.fullName
    } else {
      name = 'Fehler beim laden des Dokuments'
    }

    return {
      btnType: 'btnDoc',
      btnDoc: {
        ...defaults,
        identifier: docIdentifier,
        label: name,
      },
    }
  }
  if (button.__typename === 'NestedContentButtonType') {
    const {__typename, disclaimer, panelId, ...btnNestedContent} = button
    return {
      btnType: 'btnNestedContent',
      btnNestedContent,
    }
  }
  if (button.__typename === 'DownloadButtonType') {
    const {__typename, disclaimer, media, ...defaults} = button
    return {
      btnType: 'btnDownload',
      btnDownload: {
        ...defaults,
        fileName: '',
        media: {
          fileHash: media.fileHash ?? '',
        },
      },
    }
  }
  if (button.__typename === 'DialogButtonType') {
    // TODO we have no editor impl. for this
    // let the button value as is
    return undefined
  }
  // Check that all cases of __typename have been handled
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const exhaustiveCheck: never = button
  return undefined
}